<template>
  <div class="container">
    <!-- page counter -->
    <div>
      <page-controls />
    </div>
    <!--product list -->
    <div class="container">
      <div
        v-for="p in results"
        v-bind:key="p.document.ItemID"
        class="container"
      >
        <product
          :image="p.document.thumbnail"
          :name="p.document.ItemName"
          :description="p.document.Description"
          :globalPrice="p.document.GlobalPrice"
          :manufacturerId="p.document.ManufacturerID"
          :manufacturerName="p.document.ManufacturerName"
          :manufacturerImage="p.document.manufacturerImage"
          :commercialTypeNumber="p.document.CommercialTypeNumber"
          :isPromo="p.document.Promo"
          :itemsOnStock="p.document.ItemsOnStock"
        />
      </div>
    </div>
    <!-- page counter -->
    <div class="">
      <page-controls v-show="pageCount > 1" />
    </div>
  </div>
</template>

<script>
import PageControls from "./PageControls";
import Product from "./Product";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: { PageControls, Product },
  computed: {
    // ...mapGetters({ products: "currentPageProducts" }),
    ...mapGetters(["pageCount"]),
    ...mapState(["results"]),
  },
  methods: {
    ...mapActions([
      // "getItemsByCategoryIdAndCountryId",
      "getPromoItems",
    ]),
  },
  inject: ["eventBus"],
  created() {
    // this.eventBus.$on(
    //   "getItemsByCategoryId",
    //   this.getItemsByCategoryIdAndCountryId
    // );
    this.getPromoItems();
  },
};
</script>

<style></style>
